export const ENDPOINTS = {
  //  ---------------  AUTH  --------------------
  LOGIN: "auth/login",
  LOGOUT: "auth/logout",
  REFRESH: "auth/refresh",
  //  ---------------  ADMIN  -------------------
  ADMIN_DASHBOARD: "admin/dashboard",
  ADMIN_COURSE: "courses",
  ADMIN_GROUP: "admin/group",
  ADMIN_LESSON: "admin/lesson",
  ADMIN_USER: "admin/user",
  ADMIN_UPDATE: "admin/update",
  ADMIN_ROOM: "admin/room",
  //  --------------  TEACHER  ------------------
  TEACHER_DASHBOARD: "teacher/dashboard",
  TEACHER_GROUP: "teacher/group",
  TEACHER_LESSON: "teacher/lesson",
  TEACHER_LESSONS: "teacher/lessons",
  TEACHER_TASK: "teacher/task",
  TEACHER_HOMEWORK: "teacher/homework",
  TEACHER_COURSE_ID: "teacher/course-id",
  // Legacy path. Still served for the shipped Android build; new callers use
  // ATTENDANCE, which admins can reach too (/teacher/** is teacher-only).
  TEACHER_ATTENDANCE: "teacher/attendance",
  // ---------------  ATTENDANCE  ------------------
  ATTENDANCE: "attendance",
  ATTENDANCE_BOARD: "attendance/board",
  ATTENDANCE_ROSTER: (lessonInstanceId) => `attendance/lesson/${lessonInstanceId}/roster`,
  ATTENDANCE_LESSON: (lessonInstanceId) => `attendance/lesson/${lessonInstanceId}`,
  // ---------------  TUITION  ------------------
  // Role-neutral like ATTENDANCE: reception records, the owner reviews, and both
  // are ADMIN. A student reaches TUITION_MY_STATEMENT and nothing else.
  TUITION_PAYMENTS: "tuition/payments",
  // A card transfer's only trace: the parent's receipt, uploaded before the
  // payment row is written and opened from the statement afterwards.
  TUITION_RECEIPTS: "tuition/receipts",
  TUITION_RECEIPT: (fileId) => `tuition/receipts/${fileId}`,
  TUITION_ENTRIES: "tuition/entries",
  TUITION_REVERSE: (entryId) => `tuition/entries/${entryId}/reverse`,
  TUITION_STATEMENT: (studentId) => `tuition/students/${studentId}/statement`,
  TUITION_MY_STATEMENT: "tuition/me/statement",
  TUITION_OVERRIDE: (studentId) => `tuition/students/${studentId}/override`,
  TUITION_DEBTORS: "tuition/debtors",
  // Any student, not only debtors — reception takes cash from whoever is at the
  // desk, including a parent paying ahead.
  TUITION_STUDENTS: "tuition/students",
  TUITION_SUMMARY: "tuition/summary",
  // "Is this centre billing anybody, and if not, why not."
  TUITION_READINESS: "tuition/readiness",
  TUITION_SETTINGS: "tuition/settings",
  TUITION_ACCRUAL: "tuition/accrual",
  // ---------------  PARENT TELEGRAM  ------------------
  // Keyed by student, not by parent: the parent has no account until somebody
  // redeems the link. Parents at these centres never visit, so there is nothing
  // here for a QR, a printable, or a public join page — the token goes to a
  // phone number the centre already holds, and that is the authorisation.
  PARENT_LINKS: "telegram/student-links",
  PARENT_LINK_INVITE: (studentId) => `telegram/student-links/${studentId}`,
  PARENT_LINK_PHONE: (studentId) => `telegram/student-links/${studentId}/parent-phone`,
  PARENT_LINK_BULK: "telegram/student-links/bulk",
  PARENT_LINK_BULK_PREVIEW: "telegram/student-links/bulk/preview",
  // ---------------  STUDENT  ------------------
  STUDENT_DASHBOARD: "student/dashboard",
  STUDENT_GROUP: "student/group",
  STUDENT_LESSON: "student/lesson",
  STUDENT_LESSONS: "student/lessons",
  STUDENT_HOMEWORK: "student/homework",
  STUDENT_HOMEWORK_NOTIFICATION: "student/homework/notification",
  // ---------------  PASSWORD --------------------
  PASSWORD_RESET_REQUEST: "password/reset/request",
  PASSWORD_RESET_CONFIRM: "password/reset/confirm",
  PASSWORD_CHANGE: "password/change-password",
  // ---------------  MESSAGE --------------------
  CONVERSATION: "conversation",
  MESSAGES_UNREAD_COUNT: "direct-messages/unread/count",
  MESSAGES_DIRECT: "direct-messages/direct",
  MESSAGES_ROOM: "messages/room",
  MESSAGES: "messages",
  // ---------------  PROFILE --------------------
  PROFILE: "profile",
  PROFILE_BY_USERNAME: (username) => `profile/username/${username}`,
  PROFILE_BY_ID: (userId) => `profile/${userId}`,
  PROFILE_BIO: "profile/bio",
  PROFILE_PHOTO: "profile/photo",
  // ---------------  RANKING --------------------
  RANKING_GROUP: (groupId) => `api/rankings/group/${groupId}`,
  RANKING_GROUP_MY_RANK: (groupId) => `api/rankings/group/${groupId}/my-rank`,
  RANKING_MOCK_EXAM_SESSIONS: "api/rankings/mock-exam/sessions",
  RANKING_MOCK_EXAM: (sessionId) => `api/rankings/mock-exam/${sessionId}`,
  RANKING_MOCK_EXAM_LATEST: "api/rankings/mock-exam/latest",
  RANKING_MOCK_EXAM_MY_RANK: (sessionId) => `api/rankings/mock-exam/${sessionId}/my-rank`,
  RANKING_MOCK_EXAM_MY_RESULTS: "api/rankings/mock-exam/my-results",
  RANKING_SUBJECT_PAIRS: "api/rankings/mock-exam/subject-pairs",
  // ---------------  ADMIN MOCK EXAM --------------------
  ADMIN_MOCK_EXAM_SESSIONS: "api/admin/mock-exams/sessions",
  ADMIN_MOCK_EXAM_SESSION: (sessionId) => `api/admin/mock-exams/sessions/${sessionId}`,
  ADMIN_MOCK_EXAM_RESULTS: "api/admin/mock-exams/results",
  ADMIN_MOCK_EXAM_SESSION_RESULTS: (sessionId) => `api/admin/mock-exams/sessions/${sessionId}/results`,
  ADMIN_MOCK_EXAM_RESULT: (resultId) => `api/admin/mock-exams/results/${resultId}`,
  ADMIN_MOCK_EXAM_SEARCH_STUDENTS: "api/admin/mock-exams/students/search",
  ADMIN_MOCK_EXAM_SESSION_STUDENTS: (sessionId) => `api/admin/mock-exams/sessions/${sessionId}/students`,
  // ---------------  BRANDING & PUBLIC CONFIG --------------------
  // Unauthenticated: the login screen needs the centre's logo and whether
  // "Forgot password?" leads anywhere, before anyone has a token.
  PUBLIC_CONFIG: "public/config",
  ADMIN_BRANDING: "admin/branding",
  ADMIN_BRANDING_LOGO: "admin/branding/logo",
  // ---------------  AI USAGE --------------------
  ADMIN_AI_USAGE: "admin/ai-usage",
  // ---------------  ADMIN PASSWORD RESET --------------------
  ADMIN_PASSWORD_RESET: (userId) => `admin/password/${userId}/reset`,
  // ---------------  SHARED --------------------
  DOWNLOAD: "download",
  USERINFO: "user-info",
  MY_ACTIVITY: "me/activity",
  COURSE_OPTIONS: "courses/options",
  RESOURCES: "resources",
  RESOURCE: (id) => `resources/${id}`,
  RESOURCE_TAGS: "resources/tags",
};
